import React, { useEffect, useState } from 'react'
import apiClient from '../../services/apiClient'
import { buildApiUrl } from '../../utils/getConfiguration'

const Test = () => {
  const [projects, setProjects] = useState([])
  const fetchProjectsData = async () => {
    try {
      const response = await apiClient.get(buildApiUrl('aois'))
      setProjects(response.data)
    } catch (error) {
      console.error('Error fetching projects', error)
    }
  }
  useEffect(() => {
    fetchProjectsData()
  }, [])

  return (
    <>
      <h1>Test page</h1>
      {projects.map((project) => (
        <div key={project.aoi_ID}>
          <p>{project.Title}</p>
        </div>
      ))}
    </>
  )
}

export default Test
